<template>
    <div
        class="chats-filter"
        :class="{ flex: $store.getters.chatFilters.type === 'SEARCH_DETAIL' }"
        @click="closeOnClickOverlay"
    >
        <div class="background-wrapper">
            <div class="filter-item">
                <div class="title" v-html="$translate('BASIC')" />
                <div class="buttons grid">
                    <button
                        @click="onFilter('lastSign')"
                        class="grid"
                        :class="{ primary: filters.lastSign.selected }"
                        v-html="$translate(filters.lastSign.label)"
                    />
                    <button
                        @click="onFilter('notToday')"
                        class="grid"
                        :class="{ primary: filters.notToday.selected }"
                        v-html="$translate(filters.notToday.label)"
                    />
                    <button
                        v-if="isPremium"
                        @click="onFilter('lastWeek')"
                        class="grid"
                        :class="{ primary: filters.lastWeek.selected }"
                        v-html="$translate(filters.lastWeek.label)"
                    />
                    <button
                        @click="onFilter('friends')"
                        class="grid"
                        :class="{ primary: filters.friends.selected }"
                        v-html="'담당 회원'"
                    />
                    <button
                        @click="onFilter('dDayFriends')"
                        class="grid"
                        :class="{ primary: filters.dDayFriends.selected }"
                        v-html="'임시 대화방'"
                    />
                    <button
                        @click="onFilter('bookmark')"
                        class="grid"
                        :class="{ primary: filters.bookmark.selected }"
                        v-html="$translate(filters.bookmark.label)"
                    />
                </div>
            </div>
            <div class="filter-item">
                <div class="title-with-icon">
                    <div class="title" v-html="$translate('DATING_STATUS')" />
                    <i @click="onClickDatingStatusInfo" class="material-icons">error_outline</i>
                </div>
                <div class="buttons">
                    <button
                        @click="onFilter('harvest')"
                        :class="{ primary: filters.harvest.selected }"
                        v-html="$translate(filters.harvest.label)"
                    />
                    <button
                        @click="onFilter('bothLike')"
                        :class="{ primary: filters.bothLike.selected }"
                        v-html="$translate(filters.bothLike.label)"
                    />
                    <button
                        @click="onFilter('waitDating')"
                        :class="{ primary: filters.waitDating.selected }"
                        v-html="$translate(filters.waitDating.label)"
                    />
                </div>
            </div>
            <div class="filter-item">
                <div class="title" v-html="$translate('ITEM')" />
                <div class="buttons">
                    <button
                        @click="onFilter('hasTicket')"
                        :class="{ primary: filters.hasTicket.selected }"
                        v-html="$translate(filters.hasTicket.label)"
                    />
                    <button
                        v-if="isPremium"
                        @click="onFilter('isPremium')"
                        :class="{ primary: filters.isPremium.selected }"
                    >
                        <span v-html="$translate(filters.isPremium.label)" />
                    </button>
                </div>
            </div>
            <ChatsFilterDetail v-if="$store.getters.chatFilters.type === 'SEARCH_DETAIL'" @close="$emit('close')" />
        </div>
    </div>
</template>

<script>
import ChatsFilterDetail from './ChatsFilterDetail'

export default {
    name: 'ChatsFilter',
    components: { ChatsFilterDetail },
    computed: {
        filters() {
            return this.$store.getters.chatFilters
        },
        keysToImmediateReload() {
            return [
                'lastSign',
                'notToday',
                'lastWeek',
                'friends',
                'dDayFriends',
                'hasTicket',
                'isPremium',
                'harvest',
                'bothLike',
                'waitDating',
                'bookmark',
            ]
        },
        agent() {
            return this.$store.getters.agent || {}
        },
        isPremium() {
            return this.agent ? this.agent.is_premium : false
        },
    },
    methods: {
        onFilter(key) {
            this.filters[key].selected = !this.filters[key].selected
            if (this.keysToImmediateReload.indexOf(key) !== -1) {
                this.$store.dispatch('loadChats', { force: true })
            }
        },
        closeOnClickOverlay(event) {
            const cl = event.target.classList
            if (cl.contains('chats-filter') && !cl.contains('filters')) {
                this.$emit('close')
            }
        },
        onClickDatingStatusInfo() {
            this.$modal.custom({
                component: 'ModalDatingStatusInfo',
            })
        },
    },
}
</script>
